import Application from "../../Application";

import { IReportService } from "../../service/report/ReportService";
import { INotificationService } from "../../service/notification/NotificationService";
import Report1Presenter, {
  IReport1Presenter
} from "../../presenter/report/Report1Presenter";

export default class ShowReport1PageInteractor {
  private application: Application;
  private output?: IReport1Presenter;
  private reportService: IReportService;
  private notificationService: INotificationService;

  constructor(application, reportService, notificationService) {
    this.application = application;
    this.reportService = reportService;
    this.notificationService = notificationService;
  }

  async getReportingPeriodList() {
    try {
      return this.reportService.getReportingPeriodList();
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  execute() {
    this.output = Report1Presenter({
      application: this.application,
      initialState: {
        report1ReportingPeriodList: [],
        report1ApplicantList: [],
        report1CurrentApplicant: undefined,
        report1CurrentReportingPeriod: undefined,
        report1CurrentFormVersion: undefined,
        report1: undefined,
        formTypeList: [],
        formVersionList: [],
        report1IncludePublic: false
      }
    });

    this.getReportingPeriodList().then(
      (reportingPeriodList) =>
        this.output &&
        this.output.setReportingPeriodList(reportingPeriodList || [])
    );

    return this.output;
  }
}
